import React from "react";
import PropTypes from "prop-types";
import { Card, Typography } from "antd";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const { Title } = Typography;

const ChartCard = ({ title, data, height = 200, colors = {} }) => {
  return (
    <Card
      title={
        <Title level={5} style={{ margin: 0 }}>
          {title}
        </Title>
      }
      style={{ borderRadius: 12, height: "100%" }}
      bodyStyle={{ padding: 16 }}
    >
      <ResponsiveContainer width="100%" height={height}>
        <BarChart data={data}>
          <XAxis dataKey="month" />
          <YAxis />
          <Tooltip />
          <Bar dataKey="income" fill={colors.income || "#1890ff"} />
          <Bar dataKey="expense" fill={colors.expense || "#f5222d"} />
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
};

ChartCard.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  height: PropTypes.number,
  colors: PropTypes.shape({
    income: PropTypes.string,
    expense: PropTypes.string,
  }),
};

export default ChartCard;
